import { useState } from 'react';
import classNames from 'classnames';
import { useAppSelector } from '@Hooks/index';
import { currentMaterialHeaderRequest } from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';
import { MButton } from '@Components/Base';
import { Flex, Row, Typography } from 'antd';
import { ReactComponent as LogoCompanyIcon } from '@Icons/additional/logo-company-default.svg';
import { ReactComponent as ChevroneIcon } from '@Icons/additional/chevrone-down.svg';
import { MobileDrawer } from '@Components/Base/MDrawer';
import MaterialRequestInformation from '@Components/MainForm/components/InformationSidebar/components/MaterialRequestInformation/MaterialRequestInformation';

import styles from './action-buttons.module.css';

interface ActionButtonsProps {
  handleConfirm: () => void;
  handleBack: () => void;
  withoutInfoSection?: boolean;
  disableConfirm?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  handleConfirm,
  handleBack,
  withoutInfoSection = false,
  disableConfirm = false,
}) => {
  const { companyName } = useAppSelector(currentMaterialHeaderRequest);
  const [showUserInfo, setIsShowUserInfo] = useState(false);

  const handleShowUserInfo = (): void => {
    setIsShowUserInfo(true);
  };

  return (
    <Row
      className={classNames(styles.basicInformationContainer, {
        [styles.withoutInfoSection]: withoutInfoSection,
      })}
    >
      {!withoutInfoSection && (
        <div
          className={styles.informationOpenSection}
          onClick={handleShowUserInfo}
        >
          <Flex className={styles.informationUserSection}>
            <div>
              <LogoCompanyIcon style={{ width: '24px', height: '24px' }} />
            </div>
            <Flex className={styles.informationUserDesc} justify="center">
              <Typography.Text
                className={styles.informationUserName}
                strong
                ellipsis
              >
                <span className={styles.informationMRname}>{companyName}</span>
              </Typography.Text>
            </Flex>
            <div className={styles.informationShowMoreButton}>
              <ChevroneIcon />
            </div>
          </Flex>
        </div>
      )}
      <div className={styles.buttons}>
        <MButton onClick={handleBack} type="secondary">
          Cancel
        </MButton>
        <MButton
          type="primary"
          onClick={handleConfirm}
          disabled={disableConfirm}
        >
          Confirm
        </MButton>
      </div>
      <MobileDrawer
        open={showUserInfo}
        closable={false}
        onClose={() => setIsShowUserInfo(false)}
      >
        <MaterialRequestInformation requestHeaderStep={false} />
      </MobileDrawer>
    </Row>
  );
};

export default ActionButtons;
